<template lang="pug">
  .content
    .md-layout.md-gutter.md-alignment-center-center
      .md-layout-item.md-size-80.md-medium-size-90.md-xsmall-size-100
        md-card
          md-card-header(data-background-color="green")
            h4(class="title") Past Pitch Results
            p(class="category") Download responses for past GM pitches.
          md-card-content(v-if="error" style="text-align: center")
            p(style="color: red;") Sorry, there was an error, please try again!
          md-card-content(v-else)
            md-table
              md-table-row
                md-table-cell Stock
                md-table-cell Position
                md-table-cell Percent Yes
                md-table-cell Average Sizing
              md-table-row(v-for="pitch in allPitches" :key="pitch.id")
                md-table-cell {{ pitch.stock_name }}
                md-table-cell {{ pitch.direction }}
                md-table-cell {{ pitch.percent_yes }}
                md-table-cell ${{ pitch.average_sizing }}
                md-table-cell
                  md-button.md-raised(@click="downloadResponses(pitch)") Download Responses

            
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return{
      allPitches: null,
      user: null,
      error: null,
    };
  },
  created() {
    this.user = this.$store.state.user;
    this.getPitches();
  },
  mounted() {

  },
  methods: {
    getPitches() {
      axios.get('/api/org/get_all_pitches')
      .then((response) => {
        this.allPitches = response.data;
      }).catch((err) => {
        this.error = true;
      });
    },
    downloadResponses(pitch) {
      axios.post(`/api/org/download_pitch_responses/${pitch.id}`)
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${pitch.direction}_${pitch.stock_name}.csv`);
        document.body.appendChild(link);
        link.click();
      }).catch((err) => {
        console.log(err);
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Internal/PitchResults.vue